import { Type } from '@angular/core';
import { MyArvatoDialogConfig } from '@myarvato/shared/dialog';
import { BaseSearchService } from '../services/base-search.service';
import { SearchDtoBase } from '@myarvato/shared/models';

export function getSearchWidgetConfig<TDto extends SearchDtoBase, TService extends BaseSearchService<TDto>>(
  searchService: Type<TService>,
): MyArvatoDialogConfig {
  return {
    size: 'lg',
    showHeader: false,
    dismissableMask: true,
    providers: [{ provide: BaseSearchService, useClass: searchService }],
  };
}
